import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { ToastContainer } from "react-toastify";
import {
  toastError,
  toastSuccess,
} from "../../../../../customComponents/customToast/Toast";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";

const AddLeadStatus = () => {
  const [formData, setFormData] = useState({});
  const authToken = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("businessPartnerId");
  const navigate = useNavigate();

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          setLoading(true);
          const payload = {
            status_name: formData.status_name,
            status_desc: formData.status_desc,
            status: formData.status === "Active" ? 1 : 0,
          };
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }

          const response = await axiosInstance.post("/status/create", payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });
          if (response.status === 200) {
            return response.data;
          }
        } catch (error) {
          console.error("Error adding status:", error);
          const errorMessage =
            error.response?.data?.message || "An error occurred.";
          Swal.showValidationMessage(errorMessage);
          return false;
        }
      },
    });
    if (result.isConfirmed && result.value) {
      Swal.fire({
        title: "Success",
        text: "Lead Status updated successfully!",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/admin/manage-lead/lead-status");
      });
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire({
        title: "Cancelled",
        text: "The action has been cancelled.",
        icon: "info",
        confirmButtonText: "OK",
      });
    }
    setLoading(false);
  };

  const CustomerInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
          },
        ]
      : []),
    {
      name: "status_name",
      label: "Name",
      placeholder: "Enter Lead Status Name",
      type: "text",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z\s]*$/,
        message: "First Letter Should be Capital & Only alphabets are allowed*",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "status_desc",
      label: "Description",
      placeholder: "Enter Lead Status Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Add Lead Status</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Lead Status Details
            </span>
            <DynamicForm
              formConfig={CustomerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>

          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                handleFormSubmit(formData);
              }}
              className="submit-btn"
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default AddLeadStatus;
